import { useState } from "react";
import { Field, FormCustom } from "../template";
import { Select, Text } from "../inputs";
import { useTranslation } from "react-i18next";
import * as Yup from "yup";
import { selectValidation, stringValidation } from "../providers/validations";
import objectPath from "object-path";
import { useApp } from "../providers/app";
import { errorAlert, successAlert } from "../providers/alert";
import { useNavigate } from "react-router-dom";
import { mainApi } from "../providers/api";
import Loading from "../components/Loading";

const Manager = ({ id, current_status, factory_user, description }) => {
  const { t } = useTranslation();
  const statusList = t("status", { returnObjects: true });

  const { user } = useApp();
  const navigate = useNavigate();
  const [loading, setloading] = useState(false);
  const props = {
    editable: false,
    isDeletable: false,
    model: "order",
    text: id ? "订单信息" : "注册商标",
    id: id,
    init: {
      status: current_status,
      factory: factory_user,
      description: description,
    },
    validationSchema: Yup.object().shape({
      status: selectValidation(),
      factory: selectValidation(),
      description: stringValidation(),
    }),
  };

  const save = async (values) => {
    const { factory, status, description } = values;
    console.log("🚀 ~ save ~ factory:", factory);

    if (factory && status) {
      console.log("🚀 ~ save ~ status:", status);
      setloading(true);
      const data = {
        status: status,
        factory: factory,
        description: description,
        manager: objectPath.get(user, "id"),
      };
      if (status == "scheduled") data.started = new Date();
      if (status == "finished") data.finished = new Date();
      await mainApi({
        url: `/order/${id}`,
        method: "PUT",
        data: data,
      });
      successAlert();
      navigate(-1);
    } else errorAlert(t("order.error.save"));
  };
  return (
    <FormCustom {...props}>
      {({ submited, disabled, values, errors, handleSubmit }) => {
        return (
          <div className='flex flex-wrap bg-white my-4 p-4 rounded-md shadow-md'>
            <div className='flex w-full flex-col md:w-2/5 p-2'>
              <Field
                name='status'
                label={t("order.status")}
                disabled={false}
                component={Select}
                items={statusList}
                className='w-full'
              />
              <Field
                name='factory'
                label={t(`order.factory`)}
                disabled={false}
                component={Select}
                axio={`/user/select`}
                className='mt-4'
                axioAdapter={(data) => {
                  return data.map(({ value, label }) => ({
                    value: value,
                    label: label,
                  }));
                }}
              />
            </div>
            <div className='flex w-full flex-col md:w-3/5 p-2'>
              <Field
                name='description'
                label={t(`order.description`)}
                disabled={false}
                component={Text}
                type='textarea'
                rows={5}
                className='w-full'
              />
              {loading ? (
                <Loading width={"w-16 h-16 bg-red-500"} />
              ) : (
                <button
                  className='w-64 max-w-64 self-end mt-4'
                  type='submit'
                  onClick={() => save(values)}
                >
                  {t("order.save")}
                </button>
              )}
            </div>
          </div>
        );
      }}
    </FormCustom>
  );
};

export default Manager;
